import { makeStyles } from "@mui/styles";

export const useStyles = makeStyles(({ palette, spacing }) => ({
  avatar: {
    backgroundColor: palette.common.white,
    color: palette.primary.main,
    height: 36,
    width: 36,
  },
  "avatar--academy_passed": {
    backgroundColor: palette.common.white,
    color: palette.success.main,
  },
  button: {
    display: "flex",
    height: 48,
    maxWidth: spacing(36),
    paddingLeft: 0,
    paddingRight: 0,
    marginRight: 16,
    overflow: "hidden",
    minHeight: 36,
    minWidth: 36,
  },
  button__footer: {
    color: palette.common.white,
    fontSize: 10,
    lineHeight: "10px",
    opacity: 0.5,
  },
  button__header: {
    color: palette.common.white,
    fontSize: 16,
    lineHeight: "20px",
  },
  icon: {
    color: palette.common.white,
    fontSize: 20,
    marginLeft: spacing(1),
  },
  root: {
    alignItems: "center",
    display: "flex",
    height: "100%",
    justifyContent: "center",
    paddingRight: spacing(2),
  },
}));
